import * as React from "react";

interface MomentumIconProps {
  width?: number;
  height?: number;
  [key: string]: any;
}

const MomentumIcon: React.FC<MomentumIconProps> = ({
  width = 25,
  height = 25,
  ...props
}) => (
  <img
    src="/momentum_logo.png"
    alt="Momentum"
    width={width}
    height={height}
    style={{ objectFit: "contain" }}
    {...props}
  />
);

export default MomentumIcon;
